import React from 'react';
import { Clock, Users, Image, Key, Upload, Plus, Play } from 'lucide-react';
import Sidebar from '../../Sidebar/Sidebar';
import Navbar from '../../Navbars/UserNavbar';
import { NavLink } from 'react-router-dom';
import { Camera, ChevronDown, Lock } from 'lucide-react';

interface User {
  name: string;
  avatar: string;
}

interface StorageProps {
  used: number;
  total: number;
}

interface UploadFormProps {
    onClose?: () => void;
  }

const ActionCard = ({ icon: Icon, title, link }: { icon: React.ElementType; title: string; link: string }) => (
  <NavLink to={link}>
    <div className="bg-gray-50 p-6 rounded-lg hover:shadow-md transition-shadow cursor-pointer flex flex-col items-center justify-center space-y-4">
      <Icon className="w-6 h-6 text-orange-500" />
      <span className="text-sm font-medium text-gray-900">{title}</span>
    </div>
  </NavLink>

);

const StorageBar: React.FC<StorageProps> = ({ used, total }) => {
  const percentage = (used / total) * 100;
  return (
    <div className="w-full mt-2">
      <div className="flex justify-between text-sm mb-1">
        <span>{used}GB</span>
        <span>{total}GB</span>
      </div>
      <div className="h-2 bg-gray-200 rounded-full">
        <div
          className="h-full bg-blue-600 rounded-full"
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
};

const AddPhoto = () => {
  const user: User = {
    name: 'Dwayne Johnson',
    avatar: '/api/placeholder/32/32'
  };

  const [formData, setFormData] = React.useState({
    name: '',
    description: '',
    recipient: '',
    isPrivate: true
  });

  return (
    <div className="min-h-screen bg-white">
      <div className="flex flex-col md:flex-row">
        <Sidebar />
        {/* Main Content */}
        <main className="flex-1 p-6 relative md:ml-64">
          <Navbar />

          <h1 className="text-2xl font-bold mb-8">Welcome, {user.name.split(' ')[0]}</h1>

          
          <div className="max-w-2xl mx-auto p-4 md:p-6">
      <div className="flex justify-between items-center mb-6">
        <div className="flex gap-4">
          <span className="text-gray-700">Upload / </span>
          <span className="text-orange-500">Photo</span>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-6 mb-8">
        <button className="flex flex-col items-center justify-center p-8 border-2 border-dashed rounded-lg hover:bg-gray-50">
          <Camera className="w-8 h-8 text-gray-400 mb-2" />
          <span className="text-gray-600">Capture Photo</span>
        </button>

        <button className="flex flex-col items-center justify-center p-8 border-2 border-dashed rounded-lg hover:bg-gray-50">
          <Upload className="w-8 h-8 text-gray-400 mb-2" />
          <span className="text-gray-600">Upload from Device</span>
        </button>
      </div>

      <div className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Photo Name
          </label>
          <input
            type="text"
            placeholder="Photo Name"
            className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-orange-500"
            value={formData.name}
            onChange={e => setFormData({...formData, name: e.target.value})}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Photo Description
          </label>
          <textarea
            placeholder="Photo Description"
            className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-orange-500"
            rows={4}
            value={formData.description}
            onChange={e => setFormData({...formData, description: e.target.value})}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Recipient
          </label>
          <div className="relative">
            <select 
              className="w-full px-4 py-3 rounded-lg border border-gray-200 appearance-none pr-10 focus:outline-none focus:ring-2 focus:ring-orange-500"
              value={formData.recipient}
              onChange={e => setFormData({...formData, recipient: e.target.value})}
            >
              <option value="">Select Recipient</option>
            </select>
            <ChevronDown className="absolute right-4 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Upload
          </label>
          <div className="border-2 border-dashed rounded-lg p-8 text-center">
            <div className="flex flex-col items-center">
              <Upload className="w-8 h-8 text-gray-400 mb-4" />
              <p className="text-gray-600 mb-4">Upload Photos from your device</p>
              <button className="bg-black text-white px-6 py-2 rounded-lg hover:bg-gray-800">
                Upload Photo
              </button>
            </div>
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Access Permission
          </label>
          <div className="relative">
            <button className="w-full flex items-center justify-between px-4 py-3 rounded-lg border border-gray-200">
              <div className="flex items-center gap-2">
                <Lock className="w-4 h-4" />
                <span>Private</span>
              </div>
              <ChevronDown className="w-4 h-4 text-gray-400" />
            </button>
          </div>
        </div>

        <div className="flex justify-end gap-4">
          <button 
            // onClick={}
            className="px-6 py-2 text-gray-600 hover:text-gray-800"
          >
            Cancel
          </button>
          <button className="px-6 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600">
            Save
          </button>
        </div>
      </div>
    </div>
        </main>
      </div>
    </div>
  );
};

export default AddPhoto;





